// used in NGRhombus to define its style
enum ERhombusType {
	empty = 'empty',
	half = 'half',
	full = 'full'
}

// used by NGRhombus to determine when the pulse animation should start
enum EActivateOn {
	hover = 'hover',
	click = 'click',
	both = 'both',
	never = 'never'
}

export { ERhombusType, EActivateOn };
